import { generateClient } from 'aws-amplify/api';
const client = generateClient();

/**
 * Generates a character name based on character details
 * 
 * @param {Object} characterInfo - Basic character information
 * @param {string} characterInfo.race - Character race
 * @param {string} characterInfo.subrace - Character subrace (optional)
 * @param {string} characterInfo.background - Character background (scholar, soldier, etc)
 * @param {string} characterInfo.alignment - Character alignment
 * @returns {Promise<string>} - Generated name
 */
export const generateCharacterName = async (characterInfo) => {
  try {
    const input = {
      characterRace: characterInfo.race,
      characterAlignment: characterInfo.alignment,
      characterBackground: characterInfo.background
    };

    const result = await client.graphql({
      query: `
        query GenerateCharacterName($input: CharacterNameInput!) {
          generateCharacterName(input: $input) {
            name
          }
        }
      `,
      variables: { input }
    });

    return result.data.generateCharacterName.name;
  } catch (error) {
    console.error('Error generating character name:', error);
    
    // Fallback name generation logic in case the API fails
    const racePrefix = characterInfo.race?.substring(0, 3) || 'Mys';
    const alignmentSuffix = characterInfo.alignment?.substring(0, 2) || 'ic';
    const randomNum = Math.floor(Math.random() * 1000);
    
    return `${racePrefix}${alignmentSuffix}${randomNum}`;
  }
};